

























import Vue, { PropType } from 'vue'
import BaseButton from '@/ui/button/BaseButton.vue'
import { $editedNewsId } from '@/pages/content/news/edit/model/edit-news.model'

export default Vue.extend({
  name: 'EditNewsFooter',
  components: {
    BaseButton,
  },
  props: {
    disabled: { type: Boolean as PropType<boolean>, default: true },
    fromPage: { type: String as PropType<string> },
  },
  effector: {
    newsId: $editedNewsId,
  },
  methods: {
    onSaveClick() {
      this.$emit('save')
    },
    onSaveAndBackClick() {
      this.$emit('saveAndBackToList')
    },
  },
})
